module.exports = __webpack_public_path__ + "img/imgImgHome02.25f922e5.svg";